import * as React from "react";
import PropTypes from "prop-types";
import prefixStyles from "nx-components/utils/prefixStyles";
import UserAgent from "nx-components/UserAgent";
import PullToRefresh from "nexia_mobile/components/PullToRefresh";
import ScrollableArea from "nexia_mobile/components/Scrollable/ScrollableArea";
import TrackedScrollableArea from "nexia_mobile/components/Scrollable/TrackedScrollableArea";

const isIOS = UserAgent.isIOS();

const styles = prefixStyles({
  scrollableArea: {
    position: "relative",
  },
  wrapperDiv: {
    position: "absolute",
    // 101% Ensures that overflow scrolling is always available on iOS
    minHeight: "101%",
    width: "100%",
    // Force iOS to use the GPU to draw all children of this
    // div. Without this, it would occasionally incorrectly
    // render a white screen instead of the div contents.
    transform: "translateZ(0)",
  },
});

class ScrollableAreaWithPullToRefresh extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    childrenAbove: PropTypes.node,
    onPullToRefresh: PropTypes.func,
    pullToRefreshDisabled: PropTypes.bool,
    trackingKey: PropTypes.string,
  };

  componentWillUnmount() {
    this._targetFound = false;
  }

  _targetFound = false;

  _scrollableAreaRefCallback = (el) => {
    this._target = el;
    if (this._target && !this._targetFound) {
      // force update so that the PullToRefresh can get the
      // target (it gets undefined on first render).
      this._targetFound = true;
      this.forceUpdate();
    }
  };

  render() {
    const {
      children,
      onPullToRefresh,
      pullToRefreshDisabled,
      childrenAbove,
      trackingKey,
    } = this.props;

    const innerContent = (
      <div
        data-component-name="ScrollableAreaWithPullToRefresh"
        style={styles.wrapperDiv}
      >
        {childrenAbove}
        <PullToRefresh
          target={this._target}
          offstage={isIOS}
          disabled={pullToRefreshDisabled}
          onActivate={onPullToRefresh}
        />
        {children}
      </div>
    );

    if (trackingKey != null) {
      return (
        <TrackedScrollableArea
          captureRef={this._scrollableAreaRefCallback}
          style={styles.scrollableArea}
          trackingKey={trackingKey}
        >
          {innerContent}
        </TrackedScrollableArea>
      );
    } else {
      return (
        <ScrollableArea
          captureRef={this._scrollableAreaRefCallback}
          style={styles.scrollableArea}
        >
          {innerContent}
        </ScrollableArea>
      );
    }
  }
}

export default ScrollableAreaWithPullToRefresh;



// WEBPACK FOOTER //
// ./src/components/Scrollable/ScrollableAreaWithPullToRefresh.jsx